import { NotifyHelper } from "../../../helpers/toast";
import { eDeThiActionsObj } from "../../action-types/de-thi/IDeThiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const deThiActions = {
  ...generateActions(eDeThiActionsObj, "DE_THI"),
  ...generateActionForKey(eDeThiActionsObj, "DE_THI", "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Đã cập nhật");
  }),
  ...generateActionForKey(
    eDeThiActionsObj,
    "DE_THI",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(eDeThiActionsObj, "DE_THI", "DELETE_SUCCESS", () => {
    NotifyHelper.Success("Đã xóa");
  }),
  ...generateActionForKey(
    eDeThiActionsObj,
    "DE_THI",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDeThiActionsObj,
    "DE_THI",
    "DELETE_MULTIPLE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDeThiActionsObj,
    "DE_THI",
    "DELETE_MULTIPLE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDeThiActionsObj,
    "DE_THI",
    "PROGRESS_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDeThiActionsObj,
    "DE_THI",
    "PROGRESS_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDeThiActionsObj,
    "DE_THI",
    "CHANGE_QUESTION_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDeThiActionsObj,
    "DE_THI",
    "CHANGE_QUESTION_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDeThiActionsObj,
    "DE_THI",
    "EXPORT_TONGHOP_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDeThiActionsObj,
    "DE_THI",
    "EXPORT_TONGHOP_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
